import usePrinterCreateRouteConfig from "../../../routes/configs/printers/PrinterCreateRouteConfig";
import usePrinterEditRouteConfig from "../../../routes/configs/printers/PrinterEditRouteConfig";
import useBasicColumnConfig from "../main/config/column/default/BasicColumnConfig";
import useBooleanColumnConfig from "../main/config/column/default/BooleanColumnConfig";
import useTimestampColumnConfig from "../main/config/column/default/TimestampColumnConfig";
import DataTableConfig from "../main/config/dataTable/DataTableConfig";
import useCreateHeaderActionConfig from "../main/config/headerAction/default/CreateHeaderActionConfig";
import useDeleteRowActionConfig from "../main/config/rowAction/default/DeleteRowActionConfig";
import useDuplicateRowActionConfig from "../main/config/rowAction/default/DuplicateRowActionConfig";
import useEditRowActionConfig from "../main/config/rowAction/default/EditRowActionConfig";
import DataTable, { useDataTable } from "../main/DataTable";

function PrintersDataTable() {
  //Create the datatable config
  const config = new DataTableConfig("printers");

  //Set the datatable fetch info
  config.setFetchRequest("printers");
  config.setFetchParams({
    with_printer_location_data: true,
  });

  //Set default order
  config.setOrderBy("name");
  config.setOrderDirection("asc");

  //Set the datatble columns
  config.setColumns([
    useBasicColumnConfig("name").setLockActive(true),
    useBasicColumnConfig("label_width"),
    useBasicColumnConfig("label_height"),
    useBasicColumnConfig("dpi"),
    useBooleanColumnConfig("rotate"),
    useTimestampColumnConfig("created_at"),
    useTimestampColumnConfig("updated_at"),
  ]);

  //Set the datatable row actions
  config.setRowActions([
    useEditRowActionConfig("printer", usePrinterEditRouteConfig()),
    useDuplicateRowActionConfig("printer"),
    useDeleteRowActionConfig("printer"),
  ]);

  //Set the datatable header action
  config.setHeaderActions([
    useCreateHeaderActionConfig("printer", usePrinterCreateRouteConfig()),
  ]);

  //Create the datatable object
  const dataTable = useDataTable(config);

  return <DataTable controller={dataTable} />;
}

export default PrintersDataTable;
